import { z } from 'zod';
import { memberIdSchema } from '../identity/legacy-identity-id';
import { carePathwaySourceSchema, carePathwayTierSchema } from '../programs/schema';

// Strict pointer-shaped payload for `care.pathway.tier.changed` (ADR-052): ids,
// governed tier/source enums and the effective instant. The clinician's free-text
// `reason` stays on the row; `.strict()` turns a leak of it into a parse failure.
export const carePathwayTierChangedPayloadSchema = z
  .object({
    carePathwayId: z.string().uuid(),
    memberId: memberIdSchema,
    programDefinitionId: z.string().uuid(),
    tier: carePathwayTierSchema,
    // The tier this row supersedes; null on a program's first-ever tier row.
    previousTier: carePathwayTierSchema.nullable(),
    source: carePathwaySourceSchema,
    effectiveAt: z.string().datetime({ offset: true }),
    actorRef: z.string().nullable(),
    // Injected by buildAnnotatedDomainEvent from the analytics catalog —
    // closed to that exact value, never free text.
    status: z.literal('updated').optional(),
  })
  .strict();
export type CarePathwayTierChangedPayload = z.infer<typeof carePathwayTierChangedPayloadSchema>;
